import { tnl } from '~i18n/i18n';

export const REGEX = {
  auth_verification: /^\d{6}$/,
  injection_pattern: /^(?!.*<\/\s*\w+[^>]*>).*$/,
  date_valid: /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/,
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  just_alphabetical_characters: /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]+$/,
  just_alphabetical_numbers: /^[a-zA-ZñÑ1234567890\s]+$/,
  password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/g,
  phone: /^(?:\d{7}|3\d{9})$/,
  local_phone: /^(?:\d{7}|[36]\d{9})$/
};

export const INPUT_REQUIRED = {
  required: {
    value: true,
    message: 'form_errors.input_is_required'
  }
};

export const AUTH_VERIFICATION_PATTERN = {
  pattern: {
    value: REGEX.auth_verification,
    message: 'form_errors.auth_verification_pattern'
  }
};

export const EMAIL_PATTERN = {
  pattern: {
    value: REGEX.email,
    message: 'form_errors.email_pattern'
  }
};

export const PASSWORD_PATTERN = {
  pattern: {
    value: REGEX.password,
    message: 'form_errors.password_pattern'
  }
};

export const PHONE_PATTERN = {
  pattern: {
    value: REGEX.phone,
    message: 'form_errors.phone_pattern'
  }
};

export const LOCAL_PHONE_PATTERN = {
  pattern: {
    value: REGEX.local_phone,
    message: 'form_errors.phone_pattern'
  }
};

export const MIN_NUMBER_VALUE_PATTERN = {
  min: {
    value: 1,
    message: 'form_errors.input_number_min_value'
  }
};

export const ALPHABETICAL_CHARACTERS = {
  pattern: {
    value: REGEX.just_alphabetical_characters,
    message: 'form_errors.alphabetical_characters'
  }
};

export const ALPHABETICAL_CHARACTERS_NUMBERS = {
  pattern: {
    value: REGEX.just_alphabetical_numbers,
    message: 'form_errors.alphabetical_characters_numbers'
  }
};

export const MIN_CHARACTERS_LENGTH = {
  minLength: {
    value: 5,
    message: 'form_errors.input_number_min_document'
  }
};

export const DATE_VALID_PATTERN = {
  pattern: {
    value: REGEX.date_valid,
    message: 'form_errors.date_valid_pattern'
  }
};

export const CURRENT_DATE_PATTERN = {
  max: {
    value: new Date().toISOString().split('T')[0],
    message: 'form_errors.date_max_pattern'
  }
};

export const generateRegexValidators = (conditions: QuestionCondition[]) => {
  if (!conditions || conditions.length === 0) return undefined;

  return Object.fromEntries(
    conditions.map((condition, index) => [
      `regexValidator_${index}`,
      (value: string | number): string | undefined => {
        if (value === '' || value === null || value === undefined)
          return undefined;

        if (
          !condition.regex ||
          typeof condition.regex !== 'string' ||
          condition.regex.trim() === ''
        ) {
          return undefined;
        }

        try {
          const regex = new RegExp(condition.regex);
          return regex.test(value.toString()) ? undefined : condition.message;
        } catch {
          return tnl('labels.regex_validaton', { regex: condition.regex });
        }
      }
    ])
  );
};
